import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, Container, Row, Col } from 'reactstrap';
import MDTButton from '../../atoms/mdt-button/index.js';
import IconSet from '../../atoms/mdt-iconset/index.js';
import './notification.css';

// TODO: missing some life cyle methods from original tag.
export class MDTNotification extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: props.defaultOpen,
        };
        this.toggle = this.toggle.bind(this);
    }

    toggle(isOpen = false) {
        this.setState({ isOpen: !isOpen });

        if (this.props.toggle) {
            this.props.toggle();
        }
    }

    render() {
        const {
            button = '',
            contents = [],
            toggle: propToggle,
            title = '',
        } = this.props;

        const toggle = typeof propToggle === 'function' ? propToggle : (_isOpen) => this.toggle(_isOpen);

        const { isOpen } = this.state;
        const lineElements = contents[0] ? (
            contents.map((line, i) => (
                <p key={`noti-${i}`} dangerouslySetInnerHTML={{ __html: line }} />
            ))
        ) : (
            <p />
        );

        return (
            <Modal
                isOpen={isOpen}
                wrapClassName='modal-content'
                className={`notification-modal ${this.props.notifyType}`}
            >
                <ModalBody>
                    <Container>
                        <Row>
                            <Col xs={10} data-test='contentTitle' className='content-title'>
                                {title && <h4>{title}</h4>}
                            </Col>
                            <Col xs={2} data-test='closeModal' className='content-close'>
                                <a
                                    onClick={() => this.toggle(true)}
                                    className='close-notification'
                                    role='button'
                                    tabIndex={0}
                                    onKeyDown={() => {}}
                                >
                                    <IconSet name='cross' />
                                </a>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={10} data-test='contentSection' className='content-section'>
                                {lineElements}
                                {this.props.children}
                            </Col>
                        </Row>
                        {!!button && (
                            <Row>
                                <Col
                                    sm={{ size: 6, offset: 6 }}
                                    md={{ size: 6, offset: 6 }}
                                    className='button-section'
                                >
                                    <MDTButton
                                        className='primary'
                                        label={button}
                                        name='mdt-button'
                                        onClick={toggle}
                                        type='button'
                                        dataTest='notificationButton'
                                    />
                                </Col>
                            </Row>
                        )}
                    </Container>
                </ModalBody>
            </Modal>
        );
    }
}

MDTNotification.propTypes = {
    notifyType: PropTypes.string,
    toggle: PropTypes.func,
    defaultOpen: PropTypes.bool,
    button: PropTypes.string,
    contents: PropTypes.array,
};

MDTNotification.defaultProps = {
    notifyType: 'error',
    toggle: null,
    defaultOpen: false,
    button: '',
    contents: [],
};

export default MDTNotification;
